import React from "react";
import PropTypes from "prop-types";

const VerticalBarChart = ({ data, height = 300 }) => {
  const maxValue = Math.max(...data.map((d) => d.value));
  const barWidth = 10;
  const spacing = 25;
  const width = data.length * (barWidth + spacing);

  return (
    <svg width="100%" height={155} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{background:"rgba(254, 254, 254, 0.60)", paddingLeft:"10px"}}>
      {data.map((d, index) => {
        const barHeight = (d.value / maxValue) * (height - 20);
        return (
          <g key={index} transform={`translate(${index * (barWidth + spacing)}, ${height - barHeight})`}>
            <rect width={barWidth} height={barHeight} fill="#C5C37F" rx="12" ry="12" />
          </g>
        );
      })}
    </svg>
  );
};

VerticalBarChart.propTypes = {
  data: PropTypes.array,
  height: PropTypes.number,
  width: PropTypes.number
};

export default VerticalBarChart;
